module.exports = "//public.getcloudapp.com/packs/media/images/pro_plan_icon-b2b9b91f1131ed79ede5e1f6752c9a29.png";